import React from 'react';
import { Link } from 'react-router-dom';
import { EnvelopeSimple } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { ROUTES } from '@/config/product-contract';
import { AGENT_CONFIG } from '@/config/task-display-config';

/**
 * Email Outreach — Agent Page (Spec §2.1, §4.3, Phase 5)
 *
 * Automation page (NOT an AI agent). Shows the brand empty state
 * until outreach campaigns are configured and active.
 */

const FO_CONFIG = AGENT_CONFIG.founder_outreach || {};

// ============================================================
// EMAIL OUTREACH PAGE
// ============================================================
export default function EmailOutreach() {
    return (
        <>
            {/* Page Header */}
            <div className="mb-8">
                <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs font-semibold text-slate-400 tracking-wide">
                        Agent
                    </span>
                </div>
                <h1 className="text-[28px] font-extrabold text-slate-900 font-heading leading-tight">
                    {FO_CONFIG.label || 'Founder Outreach'}
                </h1>
                <p className="text-base text-slate-500 mt-1 max-w-2xl leading-relaxed">
                    {FO_CONFIG.description || 'Discovers and contacts founders matching your investment thesis. Every outreach is queued for your approval before sending.'}
                </p>
            </div>

            {/* Empty State */}
            <div className="flex flex-col items-center justify-center py-16 text-center">
                <EnvelopeSimple weight="light" className="w-12 h-12 text-slate-300 mb-4" />
                <h3 className="text-lg font-semibold text-slate-700 mb-1">
                    Founder Outreach
                </h3>
                <p className="text-sm text-slate-500 max-w-md mb-6">
                    Configure outreach criteria and the agent will find and contact
                    founders that match your investment thesis.
                </p>
                <Link to={ROUTES.SETTINGS}>
                    <Button className="min-h-[44px] text-base font-semibold">
                        Manage Outreach Settings
                    </Button>
                </Link>
            </div>
        </>
    );
}
